import { useToast, type ToastMessage } from '../../contexts/ToastContext';

const icons: Record<string, string> = {
  success: '\u2713',
  error: '\u2717',
  warning: '\u26A0',
  info: '\u2139',
};

const colors: Record<string, string> = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
  info: 'bg-blue-50 border-blue-200 text-blue-800',
};

const iconColors: Record<string, string> = {
  success: 'text-green-500',
  error: 'text-red-500',
  warning: 'text-yellow-500',
  info: 'text-blue-500',
};

function ToastItem({ toast }: { toast: ToastMessage }) {
  const { removeToast } = useToast();
  return (
    <div className={`flex items-start gap-3 rounded-lg border p-4 shadow-lg ${colors[toast.type]}`}>
      <span className={`text-lg ${iconColors[toast.type]}`}>{icons[toast.type]}</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">{toast.title}</p>
        {toast.detail && <p className="mt-0.5 text-xs opacity-80">{toast.detail}</p>}
      </div>
      <button onClick={() => removeToast(toast.id)} className="text-lg opacity-50 hover:opacity-100">&times;</button>
    </div>
  );
}

export default function ToastContainer() {
  const { toasts } = useToast();
  if (toasts.length === 0) return null;
  return (
    <div className="fixed right-6 top-4 z-50 flex w-96 flex-col gap-2">
      {toasts.map((t) => <ToastItem key={t.id} toast={t} />)}
    </div>
  );
}
